// custom debounce function that accumulates the issue ids upon being called
// and then calls the original function with the unique accumulated issue ids after the debounce delay

type IssueId = number;

type Function = (issueId: IssueId[]) => void;

type DebouncedFunction = (issueIds: IssueId) => void;

export const debounce = (fn: Function, delay: number): DebouncedFunction => {
	let timeoutId: ReturnType<typeof setTimeout> | null = null;
	let issueIds: Set<IssueId> = new Set();

	return (issueId) => {
		issueIds.add(issueId);

		if (timeoutId) {
			clearTimeout(timeoutId);
		}

		timeoutId = setTimeout(() => {
			fn(Array.from(issueIds));
			issueIds = new Set();
		}, delay);
	};
};
